//
//import axios from 'axios'

//
import HolidayModel from '@/models/HumanResource/HrHoliday'
import Service from '@/services/api/service'

//
export default class extends Service {

    //
    static includes = [
        'hr_employee'
    ]
    
    //
    static model = HolidayModel
}
